import React from "react";
import { Collapse, DropdownMenu, Nav, NavItem, NavLink } from "shards-react";
import { NavLink as RouteNavLink } from "react-router-dom";
import { RoutePartnersAllowed } from "../../router/AllowedRoute/RoutePartnersAllowed";
import Auth from '../../auth';

class SidebarNavItems extends React.Component {
  isAllowed(path) {
    const auth = new Auth();
    const token = auth.getAccessToken();
    const jwtToken = token ? auth.parseJwt(token) : '';

    if (jwtToken.username === undefined) {
      return true;
    }

    const partnerName =  jwtToken.username.replace('partner|', '');
    const routeAllowed = RoutePartnersAllowed().filter((list) => list.partner === partnerName);

    return routeAllowed[0].routes.includes(path);
  }

  render() {
    return (
        <div className="nav-wrapper">
          <Nav className="nav--no-borders flex-column">
            { this.isAllowed('/dashboard') &&
                <NavItem className="dashboard-nav">
                  <NavLink tag={RouteNavLink} to="/dashboard" className="main-item">
                    <i className='material-icons material-icons-outlined'> dashboard </i>
                    <div className="d-inline-block item-icon-wrapper"/>
                    <span> Dashboard </span>
                  </NavLink>
                </NavItem>
            }

            { this.isAllowed('/dashboard-live') &&
              <NavItem className="dashboard-nav">
                <NavLink tag={RouteNavLink} to="/dashboard-live" className="main-item">
                  <i className='material-icons material-icons-outlined'> dashboard </i>
                  <div
                      className="d-inline-block item-icon-wrapper"
                  />
                  <span> Dashboard live </span>
                </NavLink>
              </NavItem>
            }

            {/*<NavItem className="stat-nav">*/}
            {/*  <NavLink tag={RouteNavLink} to="/statistiques" className="main-item">*/}
            {/*    <i className='material-icons material-icons-outlined'>insert_chart_outlined</i>*/}
            {/*    <div*/}
            {/*        className="d-inline-block item-icon-wrapper"*/}
            {/*    />*/}
            {/*    <span>Statistiques</span>*/}
            {/*  </NavLink>*/}
            {/*</NavItem>*/}

            { this.isAllowed('/praticiens') &&
              <NavItem className="practitioner-nav">
                <NavLink tag={RouteNavLink} to="/praticiens"
                  className={this.props.match.path.includes('praticiens/') ? "dropdown-toggle main-item" : "main-item"}
                >
                  <i className="material-icons material-icons-outlined">local_hospital</i>
                  <div
                      className="d-inline-block item-icon-wrapper"
                  />
                  <span>Praticiens</span>
                </NavLink>
                {this.props.match.path.includes('praticiens/') &&
                  <Collapse tag={DropdownMenu} small open={true} style={{ top: 0 }} >
                    <NavLink tag={RouteNavLink}  to={`/praticiens/${this.props.match.params.id}/profil/connect`}>
                      <span className="sub-item">Profil</span>
                    </NavLink>
                    <NavLink tag={RouteNavLink}  to={`/praticiens/${this.props.match.params.id}/fichiers`}>
                      <span className="sub-item">Gérer les Documents</span>
                    </NavLink>
                    <NavLink tag={RouteNavLink}  to={`/praticiens/${this.props.match.params.id}/consultations`}>
                      <span className="sub-item">Liste des consultations</span>
                    </NavLink>
                    <NavLink tag={RouteNavLink}  to={`/praticiens/${this.props.match.params.id}/authentication`}>
                      <span className="sub-item">Authentification</span>
                    </NavLink>
                  </Collapse>
                }
              </NavItem>
            }

            { this.isAllowed('/consultations') &&
              <NavItem className="consultation-nav">
                <NavLink tag={RouteNavLink} to="/consultations"
                         className={this.props.match.path.includes('consultations/') &&
                         !this.props.match.path.includes('praticiens/') ? "dropdown-toggle main-item" : "main-item"}>
                  <i className='material-icons material-icons-outlined'>voice_chat</i>
                  <div
                      className="d-inline-block item-icon-wrapper"
                  />
                  <span>Consultations</span>
                </NavLink>
              </NavItem>
            }

            { this.isAllowed('/patients') &&
              <NavItem className="patient-nav">
                <NavLink tag={RouteNavLink} to="/patients"
                         className={this.props.match.path.includes('patients/') ? "dropdown-toggle main-item" : "main-item"}
                >
                  <i className='material-icons material-icons-outlined'>person</i>
                  <div
                      className="d-inline-block item-icon-wrapper"
                  />
                  <span>Patients</span>
                </NavLink>
                {this.props.match.path.includes('patients/') &&
                <Collapse tag={DropdownMenu} small open={true} style={{ top: 0 }} >
                  <NavLink tag={RouteNavLink} to={`/patients/${this.props.match.params.id}/profil`}>
                    <span className="sub-item">Profil</span>
                  </NavLink>
                  <NavLink tag={RouteNavLink} to={`/patients/${this.props.match.params.id}/authentication`}>
                    <span className="sub-item">Authentification</span>
                  </NavLink>
                  {/*<NavLink tag={RouteNavLink} to={`/premium/slot/patient/${this.props.match.params.id}`}>
                    <span className="sub-item">Liste des markup</span>
                  </NavLink>*/}
                </Collapse>
                }
              </NavItem>
            }

            { this.isAllowed('/languages') &&
              <NavItem className="patient-nav">
                <NavLink tag={RouteNavLink} to="/languages"
                         className={this.props.match.path.includes('patients/') ? "dropdown-toggle main-item" : "main-item"}
                >
                  <i className='material-icons material-icons-outlined'>language</i>
                  <div
                      className="d-inline-block item-icon-wrapper"
                  />
                  <span>Languages</span>
                </NavLink>
              </NavItem>
            }

            { this.isAllowed('/pharmacies') &&
              <NavItem className="patient-nav">
                <NavLink tag={RouteNavLink} to="/pharmacies"
                         className={this.props.match.path.includes('patients/') ? "dropdown-toggle main-item" : "main-item"}
                >
                  <i className='material-icons material-icons-outlined'>local_pharmacy</i>
                  <div
                      className="d-inline-block item-icon-wrapper"
                  />
                  <span>Pharmacies</span>
                </NavLink>
              </NavItem>
            }

          </Nav>
        </div>
    )
  }
}

export default SidebarNavItems;




// WEBPACK FOOTER //
// ./src/layouts/MainSidebar/SidebarNavItems.js